import { TicketModel } from '@/v2/models/ticketModel';
import { ReservedKey, getAdditionalInfoValues } from './reservedAdditionalInfo';

export const LOCATOR_CAPTIONS_TYPE = 'locatorCaptions';
export type LocatorCaptions = Partial<Record<ReservedKey<typeof LOCATOR_CAPTIONS_TYPE>, string>>;

export function getLocatorCaptions(ticket: TicketModel): LocatorCaptions {
  return getAdditionalInfoValues(ticket, LOCATOR_CAPTIONS_TYPE);
}
